import React, { Component } from "react";
import { Form, Input, Button } from "antd";
import { UserOutlined } from "@ant-design/icons";

export default class step3 extends Component {
  render() {
    const onFinish = values => {
      console.log("Received values of form: ", values);
    };
    return (
      <div className="col-md-6 mr-auto ml-auto mb-3">
        <h4> Demo Links (if available)</h4>
     

        <Form
          name="normal_login"
          className="login-form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <Form.Item
            rules={[{ required: true, message: "Please input your links" }]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="https://"
              onChange={e => this.props.change("link1", e.target.value)}
            />
          </Form.Item>

          <Form.Item
            rules={[{ required: true, message: "Please input your links" }]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="https://"
              onChange={e => this.props.change("link2", e.target.value)}
            />
          </Form.Item>

          <Form.Item
            rules={[{ required: true, message: "Please input your links" }]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="https://"
              onChange={e => this.props.change("link3", e.target.value)}
            />
          </Form.Item>

          <Form.Item
            rules={[{ required: true, message: "Please input your links" }]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="https://"
              onChange={e => this.props.change("link4", e.target.value)}
            />
          </Form.Item>
        </Form>
      </div>
    );
  }
}
